import React from "react";
import './App.css';
import ProdregForm from './components/pages/Formik';
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {

  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
        <Route path="/prodreg/fuji" element={<ProdregForm className="fuji-form" brand="Fuji" email="customers@fujibikes.com" />}></Route>
        <Route path="/prodreg/formik" element={<ProdregForm className="fuji-form" brand="Fuji" />}></Route>
        <Route path="/prodreg/se" element={<ProdregForm className="se-form" brand="SE" email="customers@sebikes.com" />}></Route>
        <Route path="/prodreg/breezer" element={<ProdregForm className="breezer-form" brand="Breezer" email="customers@breezerbikes.com" />}></Route>
        <Route path="/prodreg/tuesday" element={<ProdregForm className="tuesday-form" brand="Tuesday" email="customers@tuesdaycycles.com" />}></Route>
        <Route path="/prodreg/se2" element={<ProdregForm className="se2-form" brand="SE" email="customers@sebikes.com" />}></Route>
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

